<div class="grid-container">
    <div class="grid-x">
        <div class="large-12 medium-12 small-12 text-align-right">
            <button class="button" (click)="exportWells()">Export</button>
        </div>
        <div class="large-12 medium-12 small-12">
            <app-organization-wells-grid [data]="data" [organization]="organization" [wellIssues]="wellIssues"></app-organization-wells-grid>
        </div>
    </div>
</div>

